import React from "react";
import ReactDOM from "react-dom/client";
// import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import LoginPage from "./pages/LoginPage.jsx";
import HomePage from "./pages/HomePage.jsx";
import CertificatePage from "./pages/CertificatePage.jsx";
import DetailCertificate from "./pages/DetailCertificate.jsx";
import ViewCertificate from "./pages/ViewCertificate.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  //   <HomePage />
  // </React.StrictMode>
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/home" element={<HomePage />} />
      <Route path="/certificate" element={<CertificatePage />} />
      <Route path="/certificate/:id" element={<DetailCertificate />} />
      <Route path="/viewcertificate/:id" element={<ViewCertificate />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
